import React, { useEffect, useRef, useState } from 'react';
import AuthHeader from '../../../components/header/AuthHeader';
import BannerRight from '../../../components/BannerRight';
import AuthWrapper from '../../../components/AuthWrapper';
import rocketBoyImg from '../../../assets/images/barbfullLogo.png';
import ButtonAuth from '../../../components/ButtonAuth';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useTrackingContext } from '../../../context/trackingContext';
import useClient from '../../../hooks/useClient';
import Alert from '../../../components/Alert';
import config from '../../../config';
import Footer from '../../../components/Footer';
import Cookies from 'js-cookie';
import Input from '../../../components/Input';
import { useUserContext } from '../../../context/userContext';

const ChangeUsername = () => {
  useEffect(() => {
    trackPageView({
      pageName: 'Change Username force page'
    });
  }, []);

  const {
    handleSubmit,
    control,
    formState: { isSubmitting, isValid }
  } = useForm();

  const startsAndEndsWithAlphaNumeric = (string) =>
    /^[a-z0-9]+$/i.test(string.charAt(0)) && /^[a-z0-9]+$/i.test(string.charAt(string.length - 1));

  // uppercase and lowercase letters, spaces, special characters
  const containsValidUsernameCharacters = (string) =>
    !/^[a-zA-Z0-9]+(([',. -][a-zA-Z0-9])?[a-zA-Z0-9]*)*$/.test(string);

  const navigate = useNavigate();
  const client = useClient();
  const [showAlert, setShowAlert] = useState(false);

  const { trackFormSubmit, trackPageView, trackError } = useTrackingContext();
  const { username } = useUserContext();

  const onSubmit = async (data) => {
    console.log(data);
    trackFormSubmit({
      formName: 'Force username change submit'
    });

    try {
      const res = await client.put(`${config.everywhereApi}/users/self/profile/update-username`, {
        username: data.username
      });

      Cookies.set('_barbToken', res.data.accessToken, { expires: 1 });

      navigate('/account');
    } catch (err) {
      const error = err?.response?.data?.error;

      trackError({ error_text: error?.errorMessage });

      setShowAlert({
        text: error ? error?.errorMessage + ' - ' + error.errorCode : 'Unknown error',
        success: false
      });
    }
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="w-full lg:w-1/2 relative overflow-y-scroll left-form">
        <AuthHeader />
        <AuthWrapper className="max-w-sm">
          {username && username.length > 25 ? (
            <>
              <h1 className="font-Korolev-Bold text-5xl xl:text-5xl uppercase mb-6">
                Account <br />
                Action <br /> Required
              </h1>
              <img src={rocketBoyImg} alt="build rocket boy" className="w-full mb-8" />
              <h2 className="mb-2">Update Username</h2>
              <p className="text-black font-Korolev-Light text-base mb-8">
                Your previous username has been changed as it no longer meets our current user name
                requirements. Please choose a new username to login.
              </p>
            </>
          ) : (
            <>
              <h1 className="font-Korolev-Bold text-5xl xl:text-5xl uppercase mb-6">
                Username <br />
                Change <br /> Required
              </h1>
              <img src={rocketBoyImg} alt="build rocket boy" className="w-full mb-8" />
              <p className="text-black font-Korolev-Light text-base mb-8">
                Your username: {username} requires a change. Please update to an available name to
                login.
              </p>
            </>
          )}

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-10">
              <Controller
                defaultValue=""
                control={control}
                name="username"
                rules={{
                  required: 'Username is required',
                  minLength: { value: 3, message: 'Username must be at least 3 characters long' },
                  maxLength: {
                    value: 25,
                    message: 'Username must be at most 25 characters long'
                  },
                  validate: (value) =>
                    !startsAndEndsWithAlphaNumeric(value)
                      ? 'Username should start and end with alphanumeric'
                      : containsValidUsernameCharacters(value)
                        ? "Username can only contain alphanumeric, spaces and non-repeating special characters: , . ' -"
                        : true
                }}
                render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                  <Input
                    type="text"
                    label="Username: Public Name in Game"
                    placeholder={'Enter New Username'}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className="w-full"
                    questionIcon={true}
                    autoFocus
                    tooltip={
                      <div className="text-sm">
                        <p> Your public identity. Other users will see this in-game. </p>
                        <br />
                        <p>Do not use your real name or identifying information.</p>
                      </div>
                    }
                    error={error}
                  />
                )}
              />
            </div>

            <ButtonAuth
              isSubmitting={isSubmitting}
              isDisabled={!isValid}
              label={'submit'}
              className="mb-5"
            />
          </form>
          {showAlert && (
            <Alert setShowAlert={setShowAlert} success={showAlert.success}>
              <p className="pr-12 text-sm md:text-base">{showAlert.text}</p>
            </Alert>
          )}
        </AuthWrapper>
        <Footer />
      </div>
      <BannerRight />
    </div>
  );
};

export default ChangeUsername;
